module.exports = "<div class=\"loading-spinner\">\r\n  <span class=\"loading-text\" *ngIf=\"text\"  [ngClass]=\"{'loading-lg': size == 'lg','loading-md': size == 'md','loading-sm': size == 'sm'}\">{{text}}</span>\r\n  <i [ngClass]=\"{'loading-lg': size == 'lg','loading-md': size == 'md','loading-sm': size == 'sm'}\" class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></i>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/components/loading/loading.component.html
// module id = ../../../../../src/app/Modules/Shared/components/loading/loading.component.html
// module chunks = main